// @ai-generated 2026-08-05T00:00:00+00:00 by malte.ulfers@tngtech.com using Claude Opus 4.7
import type { SynqoCondition, SynqoRuleset } from '@Model';
import { CompareRenderer } from './CompareRenderer';
import { FilteredRenderer } from './FilteredRenderer';
import { ForEachRenderer } from './ForEachRenderer';
import { IfThenElseRenderer } from './IfThenElseRenderer';
import { LogicalGroupRenderer } from './LogicalGroupRenderer';
import { PredicateRenderer } from './PredicateRenderer';
import { RulesetReferenceRenderer } from './RulesetReferenceRenderer';

interface ConditionVisitorProps {
    node: SynqoCondition;
    referencedRulesets: Record<string, SynqoRuleset>;
}

export function ConditionVisitor({ node, referencedRulesets }: ConditionVisitorProps) {
    switch (node.type) {
        case 'compare':
            return <CompareRenderer node={node} />;
        case 'predicate':
            return <PredicateRenderer node={node} />;
        case 'and':
        case 'or':
            return <LogicalGroupRenderer node={node} referencedRulesets={referencedRulesets} />;
        case 'for_each':
            return <ForEachRenderer node={node} referencedRulesets={referencedRulesets} />;
        case 'filtered':
            return <FilteredRenderer node={node} referencedRulesets={referencedRulesets} />;
        case 'ruleset_ref':
            return <RulesetReferenceRenderer node={node} referencedRulesets={referencedRulesets} />;
        case 'if_then_else':
            return <IfThenElseRenderer node={node} referencedRulesets={referencedRulesets} />;
        default: {
            const unknown = node as { type: string };
            return (
                <div className="text-(--mantine-color-error-5) italic">Unbekannter Bedingungstyp: {unknown.type}</div>
            );
        }
    }
}
